import React from 'react'
import Navbar from './Navbar'

const AiTherapist = () => {
  return (
    <>
      <Navbar />
      <div className='container-fluid py-4 bg-container'>
        <h1 className='btn btn-primary'>Aarava - 24/7 AI Therapists</h1>
      </div>
    </>
  )
}

export default AiTherapist
